module.exports = __webpack_public_path__ + "static/simpleheroes-logo-109b432840d069125cc3ae887ea7324d.png";